/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    name: 'login',
    path: '/login',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    name: 'logout',
    path: '/logout',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/forgot-pass',
    component: import('@/views/auth/ForgotPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/create-pass',
    component: import('@/views/auth/CreatePass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/confirm-forgot-pass',
    component: import('@/views/auth/ConfirmForgotPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: import('@/views/Dashboard.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/staff',
    name: 'Staff',
    component: import('@/views/staff/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/city',
    name: 'City',
    component: import('@/views/city/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/province',
    name: 'Province',
    component: import('@/views/province/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/country',
    name: 'Country',
    component: import('@/views/country/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/training_category',
    name: 'Training Category',
    component: import('@/views/training_category/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/templates',
    name: 'Template',
    component: import('@/views/template/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/template',
    name: 'New Template',
    component: import('@/views/template/Edit.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/template/:id',
    name: 'Edit Template',
    component: import('@/views/template/Edit.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/presses',
    name: 'Press',
    component: import('@/views/press/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/press',
    name: 'New Press',
    component: import('@/views/press/Edit.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/press/:id',
    name: 'Update Press',
    component: import('@/views/press/Edit.vue'),
    meta: { layout: 'default' }
  },


  {
    path: '/landingpages',
    name: 'Landing Page',
    component: import('@/views/landingpage/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/landingpage',
    name: 'New Landing Page',
    component: import('@/views/landingpage/Edit.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/landingpage/:id',
    name: 'Update Landing Page',
    component: import('@/views/landingpage/Edit.vue'),
    meta: { layout: 'default' }
  },


  {
    path: '/training',
    name: 'Formazione',
    component: import('@/views/training/Index.vue'),
    meta: { layout: 'default' }
  },


  {
    path: '/countries_data',
    name: 'Countries Data',
    component: import('@/views/countries_data/Index.vue'),
    meta: { layout: 'default' }
  },


  {
    path: '/account',
    name: 'Accounts',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/account/:id',
    name: 'Account',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },

]
